import { render, staticRenderFns } from "./ShoppingListV1.vue?vue&type=template&id=3b476fd2&scoped=true&"
import script from "./ShoppingListV1.vue?vue&type=script&lang=js&"
export * from "./ShoppingListV1.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListV1.vue?vue&type=style&index=0&id=3b476fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b476fd2",
  null
  
)

export default component.exports